import { render, staticRenderFns } from "./inheritor-type.vue?vue&type=template&id=bcc901f6&scoped=true&"
import script from "./inheritor-type.vue?vue&type=script&lang=js&"
export * from "./inheritor-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc901f6",
  null
  
)

export default component.exports